<script setup lang="ts">
import circle from '@/assets/img/loading-circle.png';
import unicorn from '@/assets/img/loading-unicorn-new.png';

export interface Props {
  full?: boolean;
}

withDefaults(defineProps<Props>(), {
  full: false,
});
</script>

<template>
  <div id="appLoading" :class="{ 'app-loader': true, full: full }">
    <div class="spinner">
      <img alt="circle-loader" :src="circle" />
    </div>
    <img alt="unicorn-loader" :src="unicorn" />
  </div>
</template>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.app-loader {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-loader.full {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: #fff;
  z-index: 9999;
}

.spinner {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  width: 128px;
  height: 128px;
}

.app-loader img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0deg);
  width: 128px;
  height: 128px;
}
</style>
